import { Component, Input } from '@angular/core';

const SPACE = ' ';

@Component({
  selector: 'migalhas',
  templateUrl: './migalhas.component.html',
  styleUrls: ['./migalhas.component.scss'],
})
export class MigalhasComponent {
  @Input() migalhas = [];

  indiceUltimaMigalha() {
    return this.migalhas.length - 1;
  }

  isUltimaMigalha(indice) {
    return this.indiceUltimaMigalha() === indice;
  }
}
